import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  DELETE_FLAG_TYPE,
  ADDRESS_CHANGE_UPDATE_CONTENTS_VALUES,
  CHANGE_EXISTENCE,
} from 'const';
import { isNullOrUndefined, editTel } from 'utils/utils'
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const AddressChangeDetail = (props) => {
  const { insuranceType, addressChange } = props;

  return (
    <Card>
      <CardHeader
        title='住所・電話番号変更'
        className={getStylesBackgroundColor(insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更対象</p>
              <p className={styles.text}>
                {addressChange?.updateContents
                  ? ADDRESS_CHANGE_UPDATE_CONTENTS_VALUES[
                  addressChange.updateContents
                  ]
                  : '-'}
              </p>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の郵便番号</p>
              <p className={styles.text}>{addressChange?.newZipCode || '-'}</p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の住所（漢字）</p>
              <p className={styles.text}>
                {(addressChange?.newPrefecture || '') +
                  (addressChange?.newCity || '') +
                  (addressChange?.newChome || '') +
                  '　' +
                  (addressChange?.newBuilding || '') || '-'}
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>変更後の住所（カナ）</p>
              <p className={styles.text}>
                {(addressChange?.newPrefectureKana || '') +
                  (addressChange?.newCityKana || '') +
                  (addressChange?.newChomeKana || '') +
                  '　' +
                  (addressChange?.newBuildingKana || '') || '-'}
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>被保険者住所変更有無</p>
              <p className={styles.text}>
                {addressChange?.isChangeOfInsuredAddress
                  ? CHANGE_EXISTENCE[addressChange.isChangeOfInsuredAddress]
                  : '-'}
              </p>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>新電話番号</p>
              <p className={styles.text}>
                {editTel(addressChange?.newTel1,
                  addressChange?.newTel2,
                  addressChange?.newTel3)}
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>現在の登録電話番号削除</p>
              <p className={styles.text}>
                {
                  isNullOrUndefined(addressChange?.deleteTelFlg)
                    ? "-"
                    : DELETE_FLAG_TYPE[addressChange?.deleteTelFlg ? 1 : 0]
                }
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>新携帯電話番号</p>
              <p className={styles.text}>
                {editTel(addressChange?.newMobileTel1,
                  addressChange?.newMobileTel2,
                  addressChange?.newMobileTel3)}
              </p>
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.listItem}>
              <p className={getStylesLabelColorLine(insuranceType)}>現在の登録携帯電話番号削除</p>
              <p className={styles.text}>
                {
                  isNullOrUndefined(addressChange?.deleteMobileTelFlg)
                    ? "-"
                    : DELETE_FLAG_TYPE[addressChange?.deleteMobileTelFlg ? 1 : 0]
                }
              </p>
            </div>
          </Grid>
          {
            addressChange?.insuredTel1 &&
            <Grid item xs={3}>
              <div className={styles.listItem}>
                <p className={getStylesLabelColorLine(insuranceType)}>被保険者の電話番号</p>
                <p className={styles.text}>
                  {editTel(addressChange?.insuredTel1,
                    addressChange?.insuredTel2,
                    addressChange?.insuredTel3)}
                </p>
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

AddressChangeDetail.propTypes = {
  className: PropTypes.string,
};

export default AddressChangeDetail;
